<template>
  <div class="modal_wrapper">
    <div
      id="keywords_modal"
      class="modal_window white_box keywords_modal"
    >
      <div class="video_wrapper">
        <div class="heading_wrapper">
          <h3 class="heading">
            &nbsp;
          </h3>
          <button
            class="close_modal close_btn"
            @click="closeModal()"
          >
            <svg
              fill="none"
              height="32"
              viewBox="0 0 32 32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 7L7 25"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                d="M25 25L7 7"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
          </button>
        </div>
        <iframe
          id="vimeo-player"
          allowfullscreen
          frameborder="0"
          height="500px"
          src="https://player.vimeo.com/video/698563919"
          tag="updated"
          width="100%"
        />
        <button
          class="btn btn_md primary_btn"
          @click="closeModal()"
        >
          I've finished watching the video
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    window.mixpanel('Sitewide: Watch Help Video', {
      page_url: window.location.href,
    })
  },
  methods: {
    closeModal() {
      this.$parent.showHelpVideo = false;
    }
  }
}
</script>

<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 2vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  position: relative;
  margin: auto;
  width: 1000px;
  z-index: 100;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.close_btn {
  height: auto;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

.video_wrapper {
  text-align: center;
}

.video_wrapper .btn {
  height: 42px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

</style>
